export const KEYS = {
  VISIBILITY_CHANGE_EVENT: 'visibilitychange',
  CHECK_AUTH_INTERVAL: 60 * 1000, // 1 min
  CHECK_AUTH_THROTTLE: 60 * 1000,
};
